module.exports = __webpack_public_path__ + "img/20.8b01f11d.png";